import { render, staticRenderFns } from "./H5SearchPage.vue?vue&type=template&id=9b01b128&"
import script from "./H5SearchPage.vue?vue&type=script&lang=js&"
export * from "./H5SearchPage.vue?vue&type=script&lang=js&"
import style0 from "./H5SearchPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports